import AceInput from './AceInput'
import { isValidJSON } from 'Services/WeaverUtils'

JsonEditor = ({ value, ...props }) ->

  value = if typeof value is 'object'
    JSON.stringify(value, null, 2)
  else if isValidJSON(value)
    JSON.stringify(JSON.parse(value), null, 2)
  else
    value

  <AceInput value={value} {...props}/>

export default JsonEditor
